export const SITE_WIDTH = 960;



// WEBPACK FOOTER //
// ./src/constants/spacing.js